/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
import axios from "axios";

import { readToken } from "../services/localStorage.service";
import { ApiError } from "./ApiError";
import { APP_CONSTANTS } from "components/constants/AppConstants";
export const baseURL = APP_CONSTANTS.base_url;

export const pageSize = 10;

export const httpApi = axios.create({
  baseURL: baseURL,
  // baseURL: "https://webapp-backend-beta-f43i3yczga-uc.a.run.app/app/v1/",
  //baseURL: "https://webapp-backend-prod-f43i3yczga-uc.a.run.app/app/v1/",
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
httpApi.interceptors.request.use((config: any) => {
  if (
    config.url == "auth/token/" ||
    config.url == "users/google/" ||
    (config && config.url && config.url.includes("authorize_callback/"))
  ) {
    config.headers = {
      ...config.headers,
    };
  } else {
    config.headers = {
      ...config.headers,
      Authorization: `JWT ${readToken()}`,
    };
  }

  return config;
});

httpApi.interceptors.response.use(undefined, (error: any) => {
  if (error?.response?.status === 401 && window.location.pathname !== "/auth/login") {
    window.location.href = "/logout";
  }
  if (error?.response?.status === 404) {
    // window.location.href = "/404";
  }
  if (error?.response?.status === 403) {
    window.location.href = "/403";
  }
  if (error?.response?.status === 405) {
    window.location.href = "/405";
  }
  throw new ApiError<ApiErrorData>(
    error && error.response && error.response.data && error.response.data["message_description"]
      ? error.response?.data["message_description"]
      : error.response?.data["message"]
      ? // eslint-disable-next-line indent
        error.response?.data["message"]
      : // eslint-disable-next-line indent
        error.message
  );
});

export interface ApiErrorData {
  message: string;
}
